import React, { useState } from 'react'
import { Table, Button, Container, Row, Col, Input } from 'reactstrap'
import { months, years } from './monthData'

const GenerateSlip = ({ createPdf }) => {
	const [month, setMonth] = useState(null)
	const [year, setYear] = useState(null)
	const bodyRef = React.createRef()
	const downloadPdf = () => createPdf(bodyRef.current)

	const onSubmit = (event) => {
		event.preventDefault()
	}
	console.log(month, year)
	return (
		<>
			<Container fluid>

				<form onSubmit={() => onSubmit()}>
					<Row>
						<Col>
							<Input
								type="select"
								name="month"
								required
								selected={month}
								defaultValue=""
								onChange={(event) => setMonth(event.target.value)} >
								<option value="" disabled>Select Month</option>
								{
									months && months.map((month, index) => (
										<option key={month} value={index + 1}>{month}</option>
									))
								}
							</Input>
						</Col>
						<Col>
							<Input
								type="select"
								defaultValue=""
								name="month"
								required
								onChange={(event) => setYear(event.target.value)} >
								<option value="" disabled>Select Year</option>
								{
									years && years.map((year, index) => (
										<option key={year} value={year}>{year}</option>
									))
								}
							</Input>
						</Col>
						<Col>
							<Button type="submit" >Generate Slip</Button>
							<Button className="ml-2" onClick={downloadPdf}>Download Pdf</Button>
						</Col>
					</Row>
				</form>

				<section className="mt-5" ref={bodyRef}>
					<Table >
						<thead>
							<tr>
								<th>Name</th>
								<th>Salary</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Adesh</td>
								<td>75000</td>
							</tr>
						</tbody>
					</Table>
				</section>
			</Container>
		</>
	)
}

export default GenerateSlip